/**
 * Form type identifiers for different onboarding flows.
 * Used to determine which UI components and logic to apply.
 */
export enum EFormType {
  /** Standard fleet onboarding flow (insurance info + telematics + summary) */
  FLEET_ONBOARDING = "fleet_onboarding",
  /** Fleet onboarding without vehicle step */
  FLEET_ONBOARDING_2 = "fleet_onboarding_2",
  /** Claim onboarding flow for defendants/claimants (claim details + telematics + consent) */
  CLAIM_ONBOARDING = "claim_onboarding",
}

/**
 * Check if the form type is a claim onboarding flow
 */
export const isClaimOnboarding = (type: string): boolean => {
  return type === EFormType.CLAIM_ONBOARDING;
};
